<div class="mein-profil-page">
    <kiene-mobile-page-header
        [showReturnButton]="showBackButton"
        [ueberschrift]="'Mein Profil'"
    ></kiene-mobile-page-header>
    <!--
    <button mat-flat-button color="accent" style="margin-bottom: 24px" (click)="openStripePage()">
        Zahlungsinformationen und Rechnungen
    </button>
    <button mat-flat-button color="accent" style="margin-left: 24px; margin-bottom: 24px" (click)="changeSubscription()">
        {{ getTextForSubscribeButton() }}
    </button>
    -->
    <div style="margin-bottom: 12px">
        <kiene-key-value-list>
            <kiene-key-value-list-item key="E-Mail Adresse" [value]="benutzerprofil?.email"></kiene-key-value-list-item>
        </kiene-key-value-list>
    </div>

    <div class="profile-two-columns">
        <div class="profile-field profile-field--kontakt">
            <div class="one-row profile-field-title">
                <mat-icon color="primary">home</mat-icon>
                <h3 style="margin-bottom: 0; margin-left: 12px">Kontakt</h3>
                <span class="spacer"></span>
            </div>
            <div>
                <mat-form-field style="width: 100%">
                    <mat-label>Vorname</mat-label>
                    <input matInput type="text" [(ngModel)]="benutzerprofil.vorname" />
                </mat-form-field>
            </div>
            <div>
                <mat-form-field style="width: 100%">
                    <mat-label>Nachname</mat-label>
                    <input matInput type="text" [(ngModel)]="benutzerprofil.nachname" />
                </mat-form-field>
            </div>
            <div>
                <mat-form-field style="width: 100%">
                    <mat-label>Straße</mat-label>
                    <input matInput type="text" [(ngModel)]="benutzerprofil.strasse" />
                </mat-form-field>
            </div>
            <div>
                <mat-form-field style="width: 100%">
                    <mat-label>PLZ</mat-label>
                    <input matInput type="text" [(ngModel)]="benutzerprofil.plz" />
                </mat-form-field>
            </div>
            <div>
                <mat-form-field style="width: 100%">
                    <mat-label>Ort</mat-label>
                    <input matInput type="text" [(ngModel)]="benutzerprofil.ort" />
                </mat-form-field>
            </div>
            <div>
                <mat-form-field style="width: 100%">
                    <mat-label>Firmenname</mat-label>
                    <input matInput type="text" [(ngModel)]="benutzerprofil.firmenname" />
                </mat-form-field>
            </div>
            <div>
                <mat-form-field style="width: 100%">
                    <mat-label>Elemente pro Seite</mat-label>
                    <input matInput type="number" [(ngModel)]="benutzerprofil.elemente_pro_seite" />
                </mat-form-field>
            </div>

            <div class="one-row profile-field-title">
                <mat-icon color="primary">settings</mat-icon>
                <h3 style="margin-bottom: 0; margin-left: 12px">Einstellungen</h3>
                <span class="spacer"></span>
            </div>
            <div class="one-row" style="margin-top: 24px; align-items: center">
                <mat-slide-toggle [formControl]="wartzezeitFleischCtrl"
                    ><span style="font-style: italic">Wartezeit Fleisch in Tagen</span> in Tierliste anzeigen (PDF)
                </mat-slide-toggle>
                <span class="spacer"></span>
                <button mat-flat-button color="accent" (click)="updateBenutzerprofil()">
                    &Auml;nderungen speichern
                </button>
            </div>
        </div>

        <div class="profile-right-column">
            <div class="profile-field profile-field--passwort">
                <div class="one-row profile-field-title">
                    <mat-icon color="primary">password</mat-icon>
                    <h3 style="margin-bottom: 0; margin-left: 12px">Passwort &auml;ndern</h3>
                    <span class="spacer"></span>
                </div>
                <kiene-new-password
                    (changePassword)="passwortSpeichern($event)"
                ></kiene-new-password>
                <div class="profile-passwort-spacer" aria-hidden="true"></div>
            </div>

            <div class="profile-field">
                <div class="one-row profile-field-title">
                    <mat-icon color="primary">draw</mat-icon>
                    <h3 style="margin-bottom: 0; margin-left: 12px">Unterschrift</h3>
                    <span class="spacer"></span>
                </div>
                <img *ngIf="benutzerprofil?.unterschrift_png" [src]="benutzerprofil.unterschrift_png" />
                <div class="one-row" style="align-items: center; margin-top: 8px">
                    <span>Hinterlegen oder aktualisieren Sie hier Ihre digitale Unterschrift.</span>
                    <span class="spacer"></span>
                    <kiene-sign-button [buttonText]="'Unterschrift hinterlegen'" [istBenutzer]="true"></kiene-sign-button>
                </div>
            </div>
        </div>
    </div>
</div>
